//*	API-константы	*//

export const baseUrl = 'https://mesto.nomoreparties.co/v1/cohort-64';
export const myToken = 'c467341b-672a-48a9-be5b-ea4a89cc731a';